export const CLASS_TO_ADD_TO_PARAGRAPHS_SECTION_HEADER_WHEN_STICKY =
	'sticky-header-of-paragraphs-section';

export const HEIGHT_OF_PARAGRAPHS_SECTION_HEADER = 32;

export const KEYWORD_ASSIGNMENT_LINK =
	'https://porsche.sharepoint.com/sites/TRACE774/Shared%20Documents/Forms/AllItems.aspx?csf=1&web=1&e=FsRyX4&CID=c646efd0%2D83c4%2D4581%2Dbc3b%2D27b1076ce3cb&FolderCTID=0x012000A4CF1022B590A34F890CC70D77155B77&id=%2Fsites%2FTRACE774%2FShared%20Documents%2FGeneral%2FBetroffenheitsbewertung';

export const SUMMARY_GUIDLINE_LINK =
	'https://porsche.sharepoint.com/sites/GETEXPorscheintern/SitePages/Vorschriftenversion-hochladen.aspx#schritt-6-zusammenfassung-einf%C3%BCgen';

export const SUMMARY_COMPONENTS_LINK =
	'https://porsche.sharepoint.com/sites/GETEXPorscheintern/SitePages/Vorschriftenversion-hochladen.aspx#textbausteine-f%C3%BCr-zusammenfassung-der-vorschriftenversion';

export const UNDISMANTLED_PARAGRAPH_LINK =
	'https://porsche.sharepoint.com/:f:/r/sites/TRACE774/Shared%20Documents/General/Vorgehen%20f%C3%BCr%20nicht%20zerlegte%20Vorschriften%20im%20VEX-Arbeitsvorrat?csf=1&web=1&e=aXORpo';
